(function() { module.exports = window["R"]; }());